import loadable from '@loadable/component';

export const OrgDashboardInvoiceViewPageContainerLoadable = loadable(
  () => import('./OrgDashboardInvoiceViewPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardInvoiceViewPageContainer,
  },
);
